import type { SVGProps } from 'react';
const SvgCheckboxUnchecked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <rect fillOpacity={0.01} height={15} fill="#fff" width={15} rx={3.5} x={0.5} y={0.5} />
    <rect stroke="currentColor" height={15} width={15} rx={3.5} x={0.5} y={0.5} />
  </svg>
);
export default SvgCheckboxUnchecked;
